<template>
  <div class="behaviour-settings-layout py-4">
    <CContainer>
      <div
        v-if="tabs.length"
        class="behaviour-settings-tabs d-flex align-items-stretch justify-content-start flex-wrap mb-3"
        role="tablist"
        :aria-label="behaviourTerminology.tabsAriaLabel"
      >
        <DashboardTabListItem
          v-for="tab in tabs"
          :key="tab.value"
          :label="tab.label"
          :value="tab.value"
          :tab-element-id="'behaviour-settings-tab-' + tab.value"
          :is-active="activeTabValue === tab.value"
          :show-check-icon="false"
          @on-tab-click="setActiveTab"
        />
      </div>
      <router-view />
    </CContainer>
  </div>
</template>

<script>
import behaviourConstants from "@/constants/behaviourManagementConstants.js"
import DashboardTabListItem from "@/v3components/Datatables/DashboardDataTable/TabsAndFilter/DashboardTabListItem.vue"
import { computed, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

export default {
  name: "BehaviourSettingsLayout",
  components: {
    DashboardTabListItem
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const behaviourTerminology = computed(
      () => store.getters["behaviourSettings/behaviourTerminology"]
    )

    const tabs = computed(() => {
      const bt = behaviourTerminology.value
      return [
        {
          label: bt.coreValue,
          value: "core-value",
          path: behaviourConstants.PATHS.SETTINGS_CORE_VALUE
        },
        {
          label: bt.positiveBehaviours,
          value: "positive-behaviours",
          path: behaviourConstants.PATHS.SETTINGS_POSITIVE_BEHAVIOURS
        },
        {
          label: bt.automatedPointsTab,
          value: "automated-points",
          path: behaviourConstants.PATHS.SETTINGS_AUTOMATED_POINTS
        },
        {
          label: bt.customizedThemeTab,
          value: "customized-theme",
          path: behaviourConstants.PATHS.SETTINGS_CUSTOMIZED_THEME
        }
      ]
    })

    const activeTabValue = computed(() => {
      const p = route.path || ""
      if (p.includes("/positive-behaviours")) return "positive-behaviours"
      if (p.includes("/automated-points")) return "automated-points"
      if (p.includes("/customized-theme")) return "customized-theme"
      return "core-value"
    })

    const setActiveTab = (value) => {
      const tab = tabs.value.find((x) => x.value === value)
      if (tab?.path) {
        router.push(tab.path)
      }
    }

    onMounted(() => {
      store.dispatch("behaviourSettings/fetchBehaviourTerminology")
    })

    return {
      tabs,
      activeTabValue,
      setActiveTab,
      behaviourTerminology
    }
  }
}
</script>
